import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogPresets, TrackByFunctions } from '@principle-theorem/ng-shared';
import {
  IHealthcareClaim,
  IInvoice,
  type ITyroTerminal,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import {
  type ISelectedTerminal,
  ISelectTyroTerminalRequest,
  SelectTyroTerminalComponent,
} from './select-tyro-terminal.component';

@Injectable()
export class SelectTyroTerminalService {
  trackByTerminal = TrackByFunctions.ref<WithRef<ITyroTerminal>>();

  constructor(private _dialog: MatDialog) {}

  getTerminalData(
    invoice: Pick<IInvoice, 'practice' | 'items' | 'claims'>,
    claim?: IHealthcareClaim
  ): Promise<ISelectedTerminal | undefined> {
    return this._dialog
      .open<
        SelectTyroTerminalComponent,
        ISelectTyroTerminalRequest,
        ISelectedTerminal
      >(
        SelectTyroTerminalComponent,
        DialogPresets.small({
          data: { invoice, claim },
        })
      )
      .afterClosed()
      .toPromise();
  }
}
